import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectLabels() {
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <div>
      {/* <FormControl sx={{ m: 1, minWidth: 120 , margin:"0 0 1rem 0!important", color:"#fff!important", background: "linear-gradient(90deg, #05B2FF 0%, #9340E2 100%)", borderRadius:"10px"}}> */}
      <Select
      defaultValue="ETH"
        value={age}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          background: "linear-gradient(90deg, #05B2FF 0%, #9340E2 100%)",
          minWidth: "137px",
          "&& fieldset": { border: "none!important", color: "white" },
          borderRadius: "10px",
          "&:hover": {
            "&& fieldset": {
              border: "none!important",
            },
          },
          ".MuiSvgIcon-root ": {
            fill: "white !important",
          },
          marginBottom: "1rem",
          color: "white",
          ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
            { pt: "11.5px!important", pb: "11.5px!important" },
        }}
      >
        {/* <MenuItem value="">
          <em>None</em>
        </MenuItem> */}
        <MenuItem value="">Ethereum</MenuItem>
        
      </Select>
      {/* <FormHelperText>Without label</FormHelperText> */}
      {/* </FormControl> */}
    </div>
  );
}
